import { render, staticRenderFns } from "./datei-upload.vue?vue&type=template&id=4b5ded9c&scoped=true"
import script from "./datei-upload.vue?vue&type=script&lang=js"
export * from "./datei-upload.vue?vue&type=script&lang=js"
import style0 from "./datei-upload.vue?vue&type=style&index=0&id=4b5ded9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5ded9c",
  null
  
)

export default component.exports